<template>
    <div>
        <el-card>
    <el-table :data="tableData" size=mini highlight-current-row v-loading="loading" :header-cell-style = "{background:'#987AFF'}" @current-change="handleCurrentChange" :height='isMobile ? 400 : 600' :element-loading-text="$t('switch.拼命加载中')">
    <el-table-column
      v-if="!isMobile"
      type="index"
      width="70">
    </el-table-column>
    <el-table-column
      prop="meter_id"
      :label="$t('switch.水表编号')">
    </el-table-column>
    <el-table-column
      prop="command_type"
      :label="$t('switch.操作内容')"
      :width="isMobile ? '' : 150">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="status"
      :label="$t('switch.操作结果')"
      width="150">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="create_time"
      :label="$t('switch.创建时间')"
      width="150">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="send_time"
      :label="$t('switch.发送时间')"
      width="150">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="run_time"
      :label="$t('switch.完成时间')"
      width="150">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="result"
      :label="$t('switch.响应结果')"
      width="150">
    </el-table-column>
    <el-table-column v-if="isMobile" label="操作" width="90">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="showDetail(scope.row)">详情</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      @current-change="handleCurrentChange"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="meteDatas.pagesize"
      :small="isMobile"
      :pager-count="isMobile ? 5 : 7"
      :layout="isMobile ? 'prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
      :total="4">
    </el-pagination>
  <el-dialog title="详情" :visible.sync="mobileDetailVisible" width="92%" class="mobile-detail-dialog">
    <div class="mobile-detail-content">
      <div v-for="item in mobileDetailItems" :key="item.key">
        <span>{{ item.label }}：</span>{{ item.value }}
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" size="mini" @click="mobileDetailVisible = false">关闭</el-button>
    </span>
  </el-dialog>
      </el-card>
    </div>
</template>

<script>
export default {
  data () {
    return {
    // 手机端
      isMobile: false,
    // table数据
      tableData: [{
        meter_id: null,
        command_type: null,
        status: null,
        send_time: null
      }],
      // tab数据加载转圈
      loading: false,
      mobileDetailVisible: false,
      mobileDetailRow: {},
      meteDatas: {
        project_id: null,
        meter_id: null,
        token: null,
        pagenum: 1,
        pagesize: 20
      }
    }
  },
  computed: {
    mobileDetailItems () {
      const row = this.mobileDetailRow || {}
      const fieldMap = [
        { key: 'meter_id', label: this.$t('switch.水表编号') },
        { key: 'command_type', label: this.$t('switch.操作内容') },
        { key: 'status', label: this.$t('switch.操作结果') },
        { key: 'create_time', label: this.$t('switch.创建时间') },
        { key: 'send_time', label: this.$t('switch.发送时间') },
        { key: 'run_time', label: this.$t('switch.完成时间') },
        { key: 'result', label: this.$t('switch.响应结果') }
      ]
      return fieldMap.map(item => ({
        key: item.key,
        label: item.label,
        value: row[item.key] === null || row[item.key] === undefined || row[item.key] === '' ? '-' : row[item.key]
      }))
    }
  },
  created () {
    this.updateIsMobile()
    this.meteDatas.project_id = this.$store.state.print.goodsForeNo.project_id
    this.meteDatas.token = this.$store.state.print.goodsForeNo.token
    this.meteDatas.meter_id = this.$parent.meterMaid
    this.maetData()
  },
  mounted () {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateIsMobile)
  },
  methods: {
    updateIsMobile () {
      this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
    },
    maetData () {
      this.$api.waterMeter.wateDatass(this.meteDatas).then((res) => {
        console.log(res, '开关阀')
        this.tableData = res.data.data
      })
    },
    showDetail (row) {
      this.mobileDetailRow = row || {}
      this.mobileDetailVisible = true
    },
    // tab组件
    handleCurrentChange (val) {
    }
  }
}
</script>

<style lang="less" scoped>
.el-card{
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table tr{
            background-color: #F9F9F9;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
        }
@media (max-width: 768px) {
  ::v-deep .el-table__body-wrapper{
    overflow-x: hidden !important;
  }
  ::v-deep .el-table__header-wrapper{
    overflow-x: hidden !important;
  }
  ::v-deep .el-pagination{
    display: flex;
    justify-content: center;
    margin: 10px 0 4px;
  }
  .mobile-detail-dialog{
    .mobile-detail-content{
      max-height: 60vh;
      overflow-y: auto;
      div{
        line-height: 22px;
        margin-bottom: 6px;
        word-break: break-all;
        span{
          color: #606266;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
